<template>
  <div>
    <div class="table-header mt-4">
      <div class="flex items-center">
        <div class="mr-2 filter">
          <img src="@/assets/images/icons/filter.svg" alt="filter icon" />
        </div>
        <div class="table__search-input-wrapper">
          <span class="pr-2 opacity-50"><search-icon /> </span>

          <input
            type="text"
            class="table__search-input"
            placeholder="Search..."
          />
          <img src="@/assets/images/icons/search.svg" alt="search icon" />
        </div>
      </div>

      <div class="date-picker flex items-center justify-center">
        <p class="text-xs">Date Filter:</p>
        <el-date-picker
          v-model="filter.startDate"
          type="date"
          placeholder="Pick start date"
          class="mx-1"
        >
        </el-date-picker>
        <el-date-picker
          v-model="filter.endDate"
          type="date"
          placeholder="Pick end date"
        >
        </el-date-picker>
      </div>
    </div>

    <div class="responsive-table" id="table-wrapper">
      <table class="custom-table responsive-table">
        <thead>
          <tr>
            <th><input type="checkbox" class="checkbox" /></th>
            <th>QUOTATION NO.</th>
            <th>SHIPPING REF.</th>
            <th>DESCRIPTION</th>
            <th>FROM</th>
            <th>TO</th>
            <th>DISTANCE(Km)</th>
            <th>WEIGHT(Kg)</th>
            <th>DECL. VALUE(N)</th>
            <th>INSURANCE</th>
            <th>STATUS</th>
            <th class="relative" tabindex="-1">
              <span class="cursor-pointer">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g opacity="0.7">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M4 0.130371C5.86384 0.130371 7.42994 1.46057 7.87398 3.26081H16V5.34776H7.87398C7.42994 7.148 5.86384 8.4782 4 8.4782C1.79086 8.4782 0 6.60947 0 4.30428C0 1.9991 1.79086 0.130371 4 0.130371ZM4 6.39124C5.10457 6.39124 6 5.45688 6 4.30428C6 3.15169 5.10457 2.21733 4 2.21733C2.89543 2.21733 2 3.15169 2 4.30428C2 5.45688 2.89543 6.39124 4 6.39124Z"
                      fill="#383F51"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M14 17.8695C12.1362 17.8695 10.5701 16.5393 10.126 14.7391H2V12.6521H10.126C10.5701 10.8519 12.1362 9.52168 14 9.52168C16.2091 9.52168 18 11.3904 18 13.6956C18 16.0008 16.2091 17.8695 14 17.8695ZM14 15.7825C15.1046 15.7825 16 14.8482 16 13.6956C16 12.543 15.1046 11.6086 14 11.6086C12.8954 11.6086 12 12.543 12 13.6956C12 14.8482 12.8954 15.7825 14 15.7825Z"
                      fill="#383F51"
                    />
                  </g></svg
              ></span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="transaction in transactions"
            :key="transaction.id"
            class="cursor-pointer"
          >
            <!-- @click="viewContactProfile(contact.id)" -->
            <td><input type="checkbox" class="checkbox" /></td>
            <td>{{ transaction.name }}</td>
            <td>On-Demand</td>
            <td>{{ transaction.code }}</td>
            <td>{{ transaction.address }}</td>
            <td>
              {{
                transaction.contactPerson ? contact.contactPerson : contact.name
              }}
            </td>
            <td>Self</td>
            <td>MuleEx</td>
            <td></td>
            <td></td>
            <td></td>
            <td class="relative" tabindex="-1" @blur="selectedRowId = null">
              <span
                @click="
                  selectedRowId
                    ? (selectedRowId = null)
                    : (selectedRowId = transaction.id)
                "
                ><vertical-ellipsis
              /></span>
              <!-- <action-popup width="w-48" v-if="selectedRowId == transaction.id">
                <div>
                  <p
                    class="py-1"
                    @click="
                      (selectedTransaction = transaction),
                        (isBlacklistContactModal = true)
                    "
                  >
                    Blacklist this Contact
                  </p>
                  <p
                    class="py-1"
                    @click="
                      (selectedTransaction = transaction), (isLoyaltyGroupModal = true)
                    "
                  >
                    Add to Loyalty Scheme
                  </p>
                  <p class="py-1">
                    Messaging
                  </p>
                  <p class="py-1">
                    Schedule a Meeting
                  </p>
                </div>
              </action-popup> -->
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="!transactions.length">
        <empty-table-icon />
        <p class="text-center text-sm">No transactions for this contact!</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "transactions",
  props: {
    contact: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      transactions: [],
      selectedRowId: null,
      selectedTransaction: {},
      filter: {
        startDate: "",
        endDate: "",
      },
    };
  },
};
</script>

<style scoped>
.table__search-input-wrapper {
  background: #ffffff;
  width: 20vw;
}
th {
  font-size: 0.7rem;
  padding: 0.5rem 0.25rem;
}
</style>
